<template>
  <div>
    <v-row
      no-gutters
      v-if="dataUser.IndMantGaleria"
    >
      <v-col
        class="d-flex child-flex"
        cols="12"
        sm="12"
        md="12"
        lg="10"
        xl="10"
      >
        <v-expand-transition>
          <v-card
            max-width="700"
            class="mt-3 mx-auto transition-fast-in-fast-out v-card--reveal rounded-lg elevation-2"
            outlined
          >
            <v-card-text
              class="title font-weight-regular justify-space-between text-center"
            >
              <span class="grey--text text--darken-2">
                {{ currentTitle }}
              </span>
              <upLoadImgM :codArti="selected" v-if="selected.length != 0 && step === 3" />
            </v-card-text>

            <v-window v-model="step">
              <v-window-item :value="1">
                <v-overlay absolute :value="ttCategoriaNew.length === 0">
                  <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>

                <v-sheet elevation="2">
                  <v-virtual-scroll
                    :bench="benched"
                    :items="ttCategoriaNew"
                    height="400"
                    item-height="45"
                  >
                    <template v-slot:default="{ item }">
                      <v-list-item :key="item.Categoria" dense>
                        <v-list-item-content
                          @click="
                            SelectCat(100, 10, item.Categoria);
                            step++;
                          "
                          style="cursor:pointer"
                        >
                          <v-list-item-title>
                            <strong>{{ item.Nombre }}</strong>
                          </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                          <Domoapi2Categoria 
                            :titulo="item.Nombre" 
                            tipo="Categorias"
                            codigo="Logo"
                            :categoria="`${item.CodigoDiv}-${item.CodigoDep}-${item.Categoria}`"
                          />
                        </v-list-item-action>
                      </v-list-item>

                      <v-divider></v-divider>
                    </template>
                  </v-virtual-scroll>
                </v-sheet>
              </v-window-item>

              <v-window-item :value="2">
                <!-- <v-overlay absolute :value="filterconsolidado.length == 0">
                  <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay> -->
                <v-sheet elevation="2">
                  <v-virtual-scroll
                    :bench="benched"
                    :items="ttSubCategoriaNew"
                    height="400"
                    item-height="45"
                  >
                    <template v-slot:default="{ item }">
                      <v-list-item
                       
                        :key="item.SubCategoria" 
                        dense
                      >
                        <v-list-item-content
                          @click="
                            SelectScat(item.SubCategoria);
                            step++;
                          "
                          style="cursor:pointer"
                        >
                          <v-list-item-title>
                            <v-badge
                              inline
                              :color="
                                numItem(item.Categoria, item.SubCategoria) != 0
                                  ? 'accent'
                                  : 'transparent'
                              "
                              :content="numItem(item.Categoria, item.SubCategoria)"
                              class="font-weight-medium body-2 ml-2">
                            </v-badge>
                            <strong> {{ item.Nombre }}</strong>
                          </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                          <Domoapi2Imagen 
                            :titulo="item.Nombre" 
                            tipo="SubCategorias"
                            codigo="Logo"
                            :categoria="`${item.CodigoDiv}-${item.CodigoDep}-${item.Categoria}-${item.SubCategoria}`"
                          />
                        </v-list-item-action>
                      </v-list-item>

                      <v-divider></v-divider>
                    </template>
                  </v-virtual-scroll>
                </v-sheet>
              </v-window-item>

              <v-window-item :value="3">
                <div class="mt-1 text-center">
                  <v-overlay v-if="filterconsolidado.length === 0" style="z-index:3">
                    <v-progress-circular color="accent" indeterminate size="64"></v-progress-circular>
                  </v-overlay>
                </div>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-text-field
                      v-model="searchArt"
                      autofocus
                      dense
                      filled
                      placeholder="Escriba nombre o codigo del Articulo"
                      v-if="filterconsolidado.length != 0"></v-text-field>
                  </v-col>
                </v-row>

                <v-sheet elevation="2" v-if="filterconsolidado.length != 0">
                  <v-virtual-scroll :bench="benched" :items="filterBy" height="300" item-height="64">
                    <template v-slot:default="{ item }">
                      <v-list-item :key="item.Codigo">
                        <v-checkbox
                          hide-details
                          multiple
                          @change="set_salirimgt"
                          v-model="selected"
                          color="accent"
                          :value="item.Codigo"
                        ></v-checkbox>
                        <v-avatar tile size="50">
                          <img :src="imgSrc(item.Codigo)" />
                        </v-avatar>

                        <v-list-item-content>
                          <strong>{{ `Ref: ${item.Codigo} ` }}</strong>
                          <v-list-item-title>
                            {{ item.Nombre }}
                          </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action v-if="selected.length === 0">
                          <v-row no-gutters>
                            <v-col>
                              <Domoapi2Articulo 
                                :titulo="item.Nombre" 
                                tipo="Articulo"
                                :codigo="item.Codigo"
                                categoria="Principal"
                              />
                            </v-col>
                          </v-row>
                        </v-list-item-action>
                      </v-list-item>

                      <v-divider></v-divider>
                    </template>
                  </v-virtual-scroll>
                </v-sheet>
              </v-window-item>
            </v-window>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn
                :disabled="step === 1"
                text
                @click="
                  step--;
                  selected = [];
                  CLR_BUSCARSCAT();
                "
                color="error"
              >
                Atras
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-expand-transition>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
  import upLoadImg from "../components/UploadImg";
  import upLoadImgM from "../components/UploadImgMultiple";
  import imgPredet from "../components/ImgPred";
  import Domoapi2Categoria from "./DomoApi2/Domoapi2Categoria.vue";
  import Domoapi2Imagen from "./DomoApi2/Domoapi2Imagen.vue";
  import Domoapi2Articulo from "./DomoApi2/Domoapi2Articulo.vue";

  export default {
    name: "MantGalery",
    destroyed() {
    this.controller.abort();
  },
    data() {
      return {
        controller: new AbortController(),
        searchArt: "",
        benched: 0,
        step: 1,
        selected: "",
        reveal: false,
        CatSelected: false,
        SubCatSelected: false,
        CatId: 0,
        SubCatId: 0,
        idProd: "",
        updateImg: Math.floor(Math.random() * 100)
      };
    },
    beforeUpdate() {
      if (!this.salirimg) this.selected = "";
    },
    methods: {
      ...mapMutations([
        "set_varCategorias",
        "set_subcategoria",
        "set_salirimgt",
        "GET_BUSCARSCAT",
        "CLR_BUSCARSCATall",
        "CLR_BUSCARSCAT",
        "CLR_DATOS_SUBCAT",
      ]),
      ...mapActions(["consolidadoSCategoria"]),
      SelectScat(Scat) {
        this.searchArt = [];
        this.SubCatSelected = true;
        this.SubCatId = Scat;
        this.CLR_BUSCARSCATall();
      this.CLR_DATOS_SUBCAT();
       // this.GET_BUSCARSCAT(Scat);
        this.set_subcategoria(Scat);
      this.consolidadoSCategoria({ signal: this.controller.signal });
      },
      setAltImg(event) {
        //console.log(event.target)
        event.target.src = `${this.NoImg}no_image.jpg`;
      },
      SelectCat(Div, Dep, Cat) {
        console.log(Cat);
        this.CatSelected = true;
        this.CatId = Cat;
        this.CLR_BUSCARSCATall();
        this.CLR_DATOS_SUBCAT();
        this.set_varCategorias([Div, Dep, Cat]);
       // this.consolidadoSCategoria({ signal: this.controller.signal })
      },
      numItem(cat, scat) {
        let xitem = [];
        if (Object.entries(this.filterconsolidado).length !== 0) {
          xitem = this.filterconsolidado.filter(
            (x) => x.Categoria == cat && x.SubCategoria == scat
          );
        }
        return xitem.length;
      },
      imgArt(id) {
        let urlImg = null;

        let nb = this.filterconsolidado
          .filter((x) => x.Codigo === id)
          .map((x) => x.Imagen);
        urlImg = `${this.imgPeque}${nb.toString()}`;

        return urlImg;
      },
      codArticulo(cod) {
        return cod;
        //return encodeURIComponent(cod);
      },
      ChrEsp(chr) {
        const chrSplit = chr.split("")
        let newChr = ""

        chrSplit.forEach(x => {
          if (x === "/") newChr += "-"
          else if (x === ".") newChr += "-"
          else newChr += x
        })

        return newChr
      },
      imgSrc(codArt) {
        let xSrc = this.domoapi2_img
        xSrc += "Articulo/"
        xSrc += this.ChrEsp(codArt)
        xSrc += "/Principal?i=${updateImg}"
        xSrc += "i=" + this.updateImg

        return xSrc
      },
    },
    components: {
      upLoadImg,
      upLoadImgM,
      imgPredet,
      Domoapi2Categoria,
      Domoapi2Imagen,
      Domoapi2Articulo,
    },
    computed: {
      ...mapState([
        "salirimg",
        "maestro",
        "imgPeque",
        "dataUser",
        "ErrorBuscarA",
        "BuscarOverlayA",
        "NoImg",
        "domoapi2_img",
      ]),
      ...mapGetters(["filterconsolidado"]),
      filterBy() {
        let arrAll = this.filterconsolidado.filter(
          (x) =>
            x.Codigo.toLowerCase().includes(this.searchArt) ||
            x.Nombre.toLowerCase().includes(this.searchArt)
        );
        return arrAll;
      },
      titulo: function () {
        //articulo
        let xNb = "";
        return function (id) {
          if (id == 2) {
            //this.ttSubCategoriaNew[0].NombreCat;
            if (Object.entries(this.maestro).length !== 0) {
              xNb = this.ttSubCategoriaNew[0].NombreCat;
            }
          }
          if (id == 3) {
            let xxNb = this.ttSubCategoriaNew
              .filter(
                (x) =>
                  x.Categoria == this.CatId && x.SubCategoria == this.SubCatId
              )
              .map((x) => x.Nombre);
            xNb = this.ttSubCategoriaNew[0].NombreCat + "/ " + xxNb;
          }
          return xNb;
        };
      },
      currentTitle() {
        const xtitulo = this.titulo(this.step);
        switch (this.step) {
          case 1:
            return "Seleccione Categoria";
          case 2:
            return xtitulo;
          case 3:
            return xtitulo;
        }
      },
      //maestro.ttCategoria
      ttCategoriaNew: {
        get: function () {
          let xCat = []; //maestro.ttCategoria
          if (Object.entries(this.maestro).length !== 0) {
            xCat = this.maestro.ttCategoria;
          }

          return xCat;
        },
      },
      ttSubCategoriaNew: {
        get: function () {
          let xSubCat = []; //maestro.ttSubCategoria this.CatId Categoria
          if (Object.entries(this.maestro).length !== 0) {
            xSubCat = this.maestro.ttSubCategoria.filter(
              (x) => x.Categoria == this.CatId
            );
          }

          return xSubCat;
        },
      },
    },
  };
</script>

<style scoped>
  .titulo {
    font-size: 1.1rem;
    vertical-align: top;
    line-height: 30px;
    margin: 0 5px;
  }

  .v-cardgrid {
    background-color: #ffffff !important;

    border: 1px solid #002f6c !important;

    transition: opacity 0.4s ease-in-out;
    margin: 1px;
  }

  .v-card--reveal {
    bottom: 0;
    opacity: 1 !important;
    width: 100%;
  }

  .img_art {
    width: auto;
    height: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
</style>
